import React, { useState } from 'react';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import Headline from 'headline';
import Button from 'button/loading';
import Input from 'shared/form-input';
import ShopifyErrorBlock from 'shared/shopify-error-block';
import useCustomer from '@/hooks/useCustomer';

import s from './forgot-password.module.scss';

const ForgotPassword = ({ setToggle }) => {
  const customerData = useCustomer();
  const {
    handleCustomerRecover
  } = customerData;
  const [shopifyErrors, setShopifyErrors] = useState(''); // Logic flow stage for the UX
  const [resetSuccess, setResetSuccess] = useState(false); // Logic flow stage for the UX
  const [loading, setLoading] = useState(false);

  const email = useFormInput('');
  const emailErrors = useErrors({ email: email.state });
  const submitReady = useSubmitReady({
    // tests input before letting submit the request
    email: email.state
  });

  async function handleSubmit(e) {
    e.preventDefault();
    setShopifyErrors('');
    setLoading(true);

    const form = {
      email: email.state
    };

    // request to recover email

    try {
      await handleCustomerRecover({ email: form.email.value && form.email.value.toLowerCase() });
      setLoading(false);
      setResetSuccess(true);

      setTimeout(() => {
        setToggle(false);
      }, 4000);
    } catch (err) {
      throw err;
    }
  }

  return (
    // <Headline primary h5 center html="Comming Soon..." />
    <form onSubmit={handleSubmit} className={s.block}>
      <Headline center primary h5 html="Password Reset" mb30 />
      <Headline
        className={s.text}
        reg
        h6
        el="p"
        html="Please provide your email address to receive a password reset email"
      />
      <ShopifyErrorBlock shopifyErrors={shopifyErrors} />
      {resetSuccess && (
        <div className={s.resetSent}>
          <p className={s.resetSentChild}>
            Reset password email was succesfully sent!, redirecting to login
            screen...
          </p>
        </div>
      )}
      <Input
        required
        type="email"
        placeholder="Email"
        {...email.events}
        error={emailErrors.email}
        value={email.state.value}
        className={s.input}
      />
      <Button
        type="submit"
        disabled={!submitReady || loading}
        className={s.submit}
        spin={loading}
        fallbackText="Submit"
        small
      >
        Reset
      </Button>
    </form>
  );
};

export default ForgotPassword;
